/* AFERIY Collection Filters V2: mobile dropdown accessibility */
(function(){
  function init(root){
    if(!root || root.dataset.afFilterV2Ready==='true') return;
    root.dataset.afFilterV2Ready='true';
    root.querySelectorAll('.page-sidebar--horizontal .facets__wrapper .sidebarBlock-heading').forEach(function(heading){
      heading.setAttribute('role','button');
      heading.setAttribute('tabindex','0');
      function toggle(e){
        if(window.matchMedia('(min-width: 768px)').matches) return;
        e.preventDefault();
        e.stopPropagation();
        var block=heading.closest('.sidebarBlock');
        var willOpen=!block.classList.contains('is-open');
        root.querySelectorAll('.page-sidebar--horizontal .sidebarBlock.is-open').forEach(function(openBlock){openBlock.classList.remove('is-open');});
        if(willOpen) block.classList.add('is-open');
      }
      heading.addEventListener('click',toggle);
      heading.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){toggle(e);}});
    });
    document.addEventListener('click',function(e){if(!root.contains(e.target)) root.querySelectorAll('.sidebarBlock.is-open').forEach(function(b){b.classList.remove('is-open');});});
  }
  document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('.af-collection-filter-v2').forEach(init);});
  document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('.af-collection-filter-v2'));});
})();
